import { AfterViewInit, Directive, Input } from '@angular/core';
import { LcsMultiSelectComponent } from '@lcs/shared/multi-select';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ExtensionGroupOption } from '../models/extension-group-option';
import { ExtensionGroupMultiSelectDataSource } from './extension-group-multi-select-data-source';

@Directive({
    selector: 'lcs-multi-select[ndtExtensionGroupMultiSelect]',
    standalone: false
})
export class ExtensionGroupMultiSelectDirective implements AfterViewInit {
   @Input() accountId: number | null;

   constructor(private multiSelect: LcsMultiSelectComponent<ExtensionGroupOption>, private store: Store<AppState>) {
      this.multiSelect.data = new ExtensionGroupMultiSelectDataSource(this.store, []);
      this.multiSelect.displayWith = (item: ExtensionGroupOption | null) => {
         return item ? `${item.name}` : null;
      };
   }

   ngAfterViewInit(): void {
      const staticFilterOverride: string[] = [];

      if (this.accountId) {
         staticFilterOverride.push(`AccountId = ${this.accountId}`);
      }

      // This is being set twice because the lcs shared component we're using for some reason only checks the validity of the selectAll button's existence once
      this.multiSelect.data = new ExtensionGroupMultiSelectDataSource(this.store, staticFilterOverride);
   }
}
